import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Prevent pinch zoom on mobile
if (typeof window !== "undefined") {
  let lastTap = 0;
  
  // Prevent pinch zoom (multiple touches)
  document.addEventListener(
    "touchstart",
    function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  // Prevent double-tap zoom and rapid taps
  document.addEventListener(
    "touchend",
    function (event) {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;
      // Prevent double-tap zoom (taps within 300ms)
      if (tapLength < 300 && tapLength > 0) {
        event.preventDefault();
      }
      lastTap = currentTime;
    },
    { passive: false }
  );

  // Prevent gesture-based zoom (iOS Safari)
  document.addEventListener(
    "gesturestart",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener(
    "gesturechange",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener(
    "gestureend",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ToastContainer
      toastClassName={(context) =>
        `${context?.defaultClassName} relative flex py-4 px-3 rounded overflow-hidden cursor-pointer bg-white shadow-lg`
      }
      bodyClassName={(context) =>
        `${context?.defaultClassName} text-[#000] text-base font-bold`
      }
      position="bottom-left"
      autoClose={4000}
      hideProgressBar={true}
      newestOnTop={false}
      closeButton={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <App />
  </>
);
